'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Toggle;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Label = require('../typography/Label');

var _Label2 = _interopRequireDefault(_Label);

require('./toggle.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Toggle(props) {
  var type = props.type,
      label = props.label,
      id = props.id;
  return _react2.default.createElement('div', {
    className: 'toggle'
  }, _react2.default.createElement('label', {
    className: 'switch',
    htmlFor: id
  }, _react2.default.createElement('input', {
    id: id,
    type: 'checkbox'
  }), _react2.default.createElement('span', {
    className: 'slider round ' + type
  }, _react2.default.createElement('span', {
    className: 'round before'
  }))), _react2.default.createElement('span', {
    className: 'toggleLabel'
  }, _react2.default.createElement(_Label2.default, {
    label: label,
    displayStyle: 'inline-block',
    weight: '500'
  })));
}

Toggle.propTypes = {
  type: _propTypes2.default.oneOf(['secondary', 'success', 'primary', 'info', 'warning', 'danger', 'dark', 'light']),
  label: _propTypes2.default.string.isRequired,
  id: _propTypes2.default.string.isRequired
};
Toggle.defaultProps = {
  type: 'info'
};